import React, { Component } from 'react'
import {Link} from 'react-router-dom';
import Arrow from 'react-icons/lib/io/android-arrow-forward';
import style from './style.css'


class SimpleList extends Component {

    render() {
        const { items } = this.props
        return (
            <div>
                <ul className={ style.siblings }>
                { items && items.map(( node ) => 
                <Link to={ node.url }><li className={ style.item }>  <Arrow className={ style.arrow }/> { node.title }</li></Link>
                )
                }
                </ul>
            </div>
        )
    }
}

export default SimpleList



// WEBPACK FOOTER //
// ./src/components/pagescreen/simplelist/index.js